module.exports = __webpack_public_path__ + "img/infordio.2168cee2.png";